/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { qs } from 'url-parse';
import type GlobalAutomationType from '@jira/spa-apps__admin-pages-automation/src/GlobalAutomationApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Match, Query } from '@atlassian/react-resource-router';
import { RedirectToProjectType } from './project-type/index.tsx';

export const LazyGlobalAutomation: LazyComponent<typeof GlobalAutomationType> = lazyForPaint<
	typeof GlobalAutomationType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-global-automation", jiraSpaEntry: "async-global-automation" */ '@jira/spa-apps__admin-pages-automation/src/GlobalAutomationApp.tsx'
		),
	),
);

export const AutomationRedirect = (): React.JSX.Element => {
	const page = (_: Match, { selectedItem, ...rest }: Query) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
		const querystring = qs.stringify(rest, true);
		return `/automation${querystring}`;
	};
	return <RedirectToProjectType page={page} />;
};

const AsyncGlobalAutomation = (): React.JSX.Element => (
	<LazyPage Page={LazyGlobalAutomation} pageId="global-automation" shouldShowSpinner={false} />
);

export default AsyncGlobalAutomation;
